import { gql } from "@apollo/client";

export const UpdateTicketDetails = gql`
  mutation UpdateTicketDetails(
    $token: String!
    $customerID: ID!
    $ticketDetailsID: ID!
    $input: UpdateDetails!
    $user_details: SubscribedUser!
  ) {
    UpdateTicketDetails(
      token: $token
      customerID: $customerID
      ticketDetailsID: $ticketDetailsID
      input: $input
      user_details: $user_details
    ) {
      id
    }
  }
`;
